import React from "react";
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer bg-dark text-white py-3">
      <div className="container text-center footer-p">
        <p>© 2024 EZZDESK. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
